import type { QuoteWarnings } from '@repo/api-contracts';

/** 경고 배지 라벨(견적 설계 §6-1) — 목록·상세가 공유한다. */
export const QUOTE_WARNING_LABELS: Readonly<Record<keyof QuoteWarnings, string>> = {
  productHidden: '상품 숨김',
  productDeleted: '상품 삭제',
  colorUnavailable: '색상 공급 불가',
};

const WARNING_ORDER: readonly (keyof QuoteWarnings)[] = [
  'productHidden',
  'productDeleted',
  'colorUnavailable',
];

/** 켜진 경고의 라벨만 고정 순서로 돌려준다. */
export const activeQuoteWarnings = (warnings: QuoteWarnings): string[] =>
  WARNING_ORDER.filter((key) => warnings[key]).map((key) => QUOTE_WARNING_LABELS[key]);
